import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import authService from '../../services/auth';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in URL');
          navigate('/community', { replace: true });
          return;
        }

        const sessionId = sessionIdMatch[1];
        
        // Exchange session_id for session_token
        const result = await authService.exchangeSession(sessionId);
        
        if (result.user) {
          // Store user data
          authService.storeUser(result.user);
          
          // Navigate to community with user data
          navigate('/community', { 
            replace: true,
            state: { user: result.user }
          });
        } else {
          throw new Error('No user data received');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/community', { replace: true });
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0a0b0c] flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#00d4aa] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-white/60">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
